import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { JSONSchema7, JSONSchema7Object } from 'json-schema';
import { SessionItemData } from 'src/app/workflow/services/session-item-data';

type EntryType = { key: string, value: JSONSchema7, property: string[], required: boolean};
@Component({
	selector: 'workflow-object-renderer',
	templateUrl: './object-renderer.component.html',
	styleUrls: ['./object-renderer.component.less']
})
export class ObjectRendererComponent implements OnChanges {

	@Input() schema: JSONSchema7Object;

	@Input() data: SessionItemData;

	@Input() property: string[];

	@Input() required: boolean;

	entries: EntryType[] = [];

	ngOnChanges(changes: SimpleChanges): void {
		if (changes?.schema && this.schema) {
			const keys = new Set<string>();
			if (this.schema.$order) {
				for (const key of this.schema.$order as string[]) {
					keys.add(key);
				}
			}
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			for (const key in this.schema.properties as any) {
				keys.add(key);
			}

			const entries: EntryType[] = [];
			const requiredEntries: string[] = this.schema?.required as string[];
			for (const key of keys) {
				const property = this.schema.properties[key];
				if (property) {

					entries.push({key: key, value: property, property: this.property.concat(key), required: !!requiredEntries?.includes(key)});
				}
			}

			this.entries = entries;
		}
	}

}
